/**
 * ChatHeader - Deborah Chat header with connection status and controls
 */
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';
import { 
  X, 
  Bot,
  Phone,
  CheckCircle2,
  RefreshCw,
  WifiOff,
  Wifi
} from 'lucide-react';

const ChatHeader = ({ 
  session, 
  connectionStatus, 
  retryCount, 
  maxRetries,
  loading,
  onResolve, 
  onClose 
}) => {
  const getConnectionBadge = () => {
    switch (connectionStatus) {
      case 'disconnected':
        return (
          <Badge className="bg-red-500/20 text-red-600 border-0 text-xs">
            <WifiOff className="w-3 h-3 mr-1" />
            Offline
          </Badge>
        );
      case 'reconnecting':
        return (
          <Badge className="bg-amber-500/20 text-amber-600 border-0 text-xs">
            <RefreshCw className="w-3 h-3 mr-1 animate-spin" />
            Reconnecting...
          </Badge>
        );
      default:
        return (
          <Badge className="bg-emerald-500/20 text-emerald-600 border-0 text-xs">
            <Wifi className="w-3 h-3 mr-1" />
            Online
          </Badge>
        );
    }
  };

  return (
    <div className="bg-gradient-to-r from-emerald-500 to-emerald-600 p-4 text-white">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="relative">
            <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center">
              <Bot className="w-6 h-6" />
            </div>
            <span className={`absolute -bottom-0.5 -right-0.5 w-3 h-3 rounded-full border-2 border-emerald-500 ${
              connectionStatus === 'connected' ? 'bg-green-400' : 
              connectionStatus === 'reconnecting' ? 'bg-amber-400 animate-pulse' : 
              'bg-red-400'
            }`}></span>
          </div>
          <div>
            <h3 className="font-semibold">Deborah</h3>
            <p className="text-xs text-white/80">
              {session?.status === 'escalated' ? 'Waiting for human agent...' : 'ParachPay Support'}
            </p>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {session && session.status !== 'resolved' && (
            <Button
              variant="ghost"
              size="icon"
              onClick={onResolve}
              className="h-8 w-8 text-white hover:bg-white/20"
              title="End chat"
              disabled={loading}
            >
              <CheckCircle2 className="w-4 h-4" />
            </Button>
          )}
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="h-8 w-8 text-white hover:bg-white/20"
          >
            <X className="w-4 h-4" />
          </Button>
        </div>
      </div>
      
      {/* Status Badges */}
      <div className="flex items-center gap-2 mt-2">
        {getConnectionBadge()}
        {session?.status === 'escalated' && (
          <Badge className="bg-orange-500/20 text-white border-orange-400/50">
            <Phone className="w-3 h-3 mr-1" />
            Human Support
          </Badge>
        )}
        {retryCount > 0 && (
          <Badge className="bg-amber-500/20 text-white border-amber-400/50 text-xs">
            Retry {retryCount}/{maxRetries}
          </Badge>
        )}
      </div>
    </div>
  );
};

export default ChatHeader;
